
import { Chip, Grid, Stack, Typography } from '@mui/material';
import { calculateTotalTripTime, getBagsByLeg, getStops } from '~/modules/helpers';
import { Carrier, Leg, LegGroup, PassengerLegBaggage, PassengerPricing, TravelClassOption } from '~/types';
import BookingExtras from './BookingExtras';
import { TRAVEL_CLASS } from '~/literals';
import FlightCardItemLeg from './FlightCardItemLeg';
import { ZoomIn } from '@mui/icons-material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import BookingExtrasWithPassengerDetails from './BookingExtrasWithPassengerDetails';

export interface FlightCardItemOverviewProps {
  legGroup: LegGroup;
  passengerPricing: PassengerPricing[];
  onDetailsButtonClicked?: () => void;
  passengerLegBaggage?: PassengerLegBaggage[];
  isSearchPage?: boolean;
}

function FlightCardItemOverview({ legGroup, passengerPricing, onDetailsButtonClicked, passengerLegBaggage, isSearchPage }: FlightCardItemOverviewProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const firstLeg = legGroup.legs[0];
  const lastLeg = legGroup.legs[legGroup.legs.length - 1];
  const duration = legGroup.duration || calculateTotalTripTime(legGroup.legs);

  const overviewLeg: Leg = {
    ...firstLeg,
    departure: firstLeg.departure,
    arrival: lastLeg.arrival,
    duration,
  }

  const bagsByLeg = getBagsByLeg(passengerPricing);

  const cabin = passengerPricing[0]?.fareDetailsByTripLeg[0]?.cabin;

  let carriersSet = new Set<string>();
  let carriers: Carrier[] = [];
  legGroup.legs.forEach(leg => {
    if (!carriersSet.has(leg.operatedBy.code)) {
      carriersSet.add(leg.operatedBy.code);
      carriers.push(leg.operatedBy);
    }
  });

  return (
    <Grid container>
      <Grid item xs={12}>
        <FlightCardItemLeg
          leg={overviewLeg}
          carriers={carriers}
          legBottomContent={(
            <Typography variant='subtitle2' sx={{ textAlign: 'center' }}><Chip size="small" label={getStops(legGroup.legs.length)} color="primary" /></Typography>
          )}
        />
      </Grid>
      <Grid item xs={12} pt={.8}>
        <Grid container spacing={0}>
          <Grid item xs={8}>
            <Stack direction="row" spacing={1}>
              {
                !passengerLegBaggage &&
                <Chip
                  size="small"
                  label={
                    <BookingExtras
                      bags={bagsByLeg[firstLeg.legId]}
                      isSearchPage={isSearchPage}
                    />
                  }
                />
              }
              <Chip style={{ maxWidth: 100 }} size="small" label={TRAVEL_CLASS[cabin as keyof TravelClassOption]} />

            </Stack>

            {
              passengerLegBaggage &&
              <BookingExtrasWithPassengerDetails passengerLegBaggage={passengerLegBaggage.filter(b => b.legId === firstLeg.legId)} />
            }
          </Grid>
          <Grid xs={isSmallScreen ? 12 : 4} item textAlign="right" mt={isSmallScreen ? 2 : 0}>
            {onDetailsButtonClicked &&
              <Chip
                size="small"
                color="primary"
                label="View flight details"
                sx={{ color: '#fff' }}
                onClick={onDetailsButtonClicked}
                icon={<ZoomIn />}
              />
            }
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
}


export default FlightCardItemOverview;
